import React from 'react';
import {
  ResponsiveSection,
  ResponsiveSectionProps as ModeReactResponsiveSectionProps,
} from '@stitch-fix/mode-react';

export type ResponsiveSectionProps = ModeReactResponsiveSectionProps;

const standardizedPadding = {
  px: { lg: 2, xxl: 0, sm: 1 },
  width: 'xxlarge',
} as ResponsiveSectionProps;

/**
 * The ContentModule standardizes the padding and width of each content, like carousels and promotional.
 * Wrap the content in a ContentModule to ensure consistent padding and width. See ProductDetailsPage as an example.
 */
const ContentModule = ({
  children,
}: {
  children: React.ReactNode;
}): JSX.Element | null => {
  return (
    <ResponsiveSection data-testid="content-module" {...standardizedPadding}>
      {children}
    </ResponsiveSection>
  );
};

export default ContentModule;
